import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Layout as ALayout, Menu } from "antd";
import { isNil, pipe, split, head, last, equals, isEmpty, reduce, has, groupBy, mergeRight, filter, not } from "ramda";
import { Link, useLocation, useNavigate, useRoutes } from "react-router-dom";
import { SuspenseLoading } from "@/components/Loading";
import TagsView, { ActionType, reducer } from "./tagsView";
import { useEffect, useMemo, useReducer, useRef } from "react";
import KeepAlive from "@/components/KeepAlive";
import { ErrorBoundary } from "@/components/errorBoundary";
import { getLatchRouteByEle, makeRouteObject, updateBodyTitle } from "@/router/utils";
import { activeRoute } from "@/hooks/useRoute";
import { useStore, useStoreValue } from "@/hooks";
import { DataPermissionState, LoginInfoState } from "@/store/globalStore";
const func = pipe(split(":"), head);
function getGoto(to) {
    const _to = func(to);
    return _to ? _to : "";
}
function mergePtah(path) {
    let paterPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    let pat = getGoto(path);
    pat = pat.startsWith("/") ? pat : "/" + pat;
    return paterPath + pat;
}
const getCode = (routes, codes, dataPermission)=>{
    return reduce((codes, item)=>{
        var _item_meta;
        // 有code & 必须是叶子节点 & 没有查询过
        if (!isNil(item.children) && !isEmpty(item.children)) {
            getCode(item.children, codes, dataPermission);
        }
        if (((_item_meta = item.meta) === null || _item_meta === void 0 ? void 0 : _item_meta.code) && isNil(item.children) && !has(item.meta.code, dataPermission)) {
            codes.push(item.meta.code);
        }
        return codes;
    }, codes, routes);
};
// 渲染导航栏
function renderMenu(data, path) {
    return reduce((items, route)=>{
        var _route_meta, _route_meta1, _route_meta2;
        if (route.alwaysShow) {
            return items;
        }
        const thisPath = mergePtah(route.path, path);
        const children = filter((route)=>not(route.alwaysShow), route.children ?? []);
        const hasChildren = isNil(children) || isEmpty(children);
        items.push({
            key: route.name,
            title: (_route_meta = route.meta) === null || _route_meta === void 0 ? void 0 : _route_meta.title,
            label: !hasChildren ? /*#__PURE__*/ _jsx("span", {
                className: "a-black",
                children: (_route_meta1 = route.meta) === null || _route_meta1 === void 0 ? void 0 : _route_meta1.title
            }) : /*#__PURE__*/ _jsx(Link, {
                to: thisPath,
                className: "a-black",
                children: (_route_meta2 = route.meta) === null || _route_meta2 === void 0 ? void 0 : _route_meta2.title
            }),
            children: hasChildren ? undefined : renderMenu(children, thisPath)
        });
        return items;
    }, [], data);
}
function getMatchRouteObj(ele) {
    var _data_meta;
    if (isNil(ele)) {
        return null;
    }
    const matchRoutes = getLatchRouteByEle(ele);
    if (isNil(matchRoutes)) {
        return null;
    }
    const selectedKeys = reduce((selectedKeys, res)=>{
        const route = res.route;
        if (route.name) {
            selectedKeys.push(route.name);
        }
        return selectedKeys;
    }, [], matchRoutes);
    const matchRoute = last(matchRoutes);
    const data = matchRoute === null || matchRoute === void 0 ? void 0 : matchRoute.route;
    updateBodyTitle(matchRoutes);
    return {
        key: data.layout ? (matchRoute === null || matchRoute === void 0 ? void 0 : matchRoute.pathnameBase) ?? "" : (matchRoute === null || matchRoute === void 0 ? void 0 : matchRoute.pathname) ?? "",
        title: (data === null || data === void 0 ? void 0 : (_data_meta = data.meta) === null || _data_meta === void 0 ? void 0 : _data_meta.title) ?? "",
        name: (data === null || data === void 0 ? void 0 : data.name) ?? "",
        selectedKeys,
        cache: data.cache
    };
}
export default function Layout(param) {
    let { route } = param;
    const eleRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const [tagsViewList, dispatch] = useReducer(reducer, []);
    const [dataPermission, setDataPermission] = useStore(DataPermissionState);
    const loginInfo = useStoreValue(LoginInfoState);
    const codes = useMemo(()=>{
        return getCode(route.children ?? [], [], dataPermission);
    }, [
        dataPermission,
        route.children
    ]);
    useEffect(()=>{
        if (!isEmpty(codes) && loginInfo.userNo) {
            API.appCenter.view.getViewByUserCode.request({
                menuCodes: codes.join(","),
                userCode: loginInfo.userNo
            }).then((param)=>{
                let { success, data } = param;
                if (success) {
                    const newDataPermission = mergeRight(reduce((obj, code)=>{
                        obj[code] = undefined;
                        return obj;
                    }, {}, codes), // 一个页面可能会有分页/详情两个视图，所以需要用数组
                    groupBy((i)=>{
                        return i.pageCode ?? "";
                    }, data || []));
                    setDataPermission((dataPermission)=>{
                        return mergeRight(dataPermission, newDataPermission);
                    });
                }
            });
        }
    }, [
        codes,
        loginInfo.userNo,
        setDataPermission
    ]);
    // 生成子路由
    const routeObject = useMemo(()=>{
        if (route.children) {
            return makeRouteObject(route.children, dispatch);
        }
        return [];
    }, [
        route.children
    ]);
    const ele = useRoutes(routeObject, location);
    // 计算 匹配的路由name
    const matchRouteObj = useMemo(()=>{
        eleRef.current = ele;
        return getMatchRouteObj(ele);
    // eslint-disable-next-line
    }, [
        routeObject,
        location
    ]);
    // 缓存渲染 & 判断是否404
    useEffect(()=>{
        if (matchRouteObj) {
            if (matchRouteObj.cache) {
                dispatch({
                    type: ActionType.add,
                    payload: {
                        ...matchRouteObj
                    }
                });
            }
        } else if (!equals(location.pathname, route.path) && !equals(location.pathname, route.path + "/")) {
            navigate({
                pathname: "/404"
            });
        }
    }, [
        location.pathname,
        matchRouteObj,
        navigate,
        route.path
    ]);
    activeRoute.setActiveRoute(matchRouteObj);
    const items = useMemo(()=>{
        return renderMenu(route.children ?? [], route.path);
    }, [
        route.children,
        route.path
    ]);
    const keepAliveList = useMemo(()=>reduce((list, item)=>{
            if (item.cache) {
                list.push(item.key);
            }
            return list;
        }, [], tagsViewList), [
        tagsViewList
    ]);
    return /*#__PURE__*/ _jsxs(ALayout, {
        children: [
            /*#__PURE__*/ _jsx(ALayout.Sider, {
                breakpoint: "lg",
                width: 180,
                theme: "light",
                collapsedWidth: "0",
                style: {
                    overflow: "auto",
                    height: "100vh",
                    position: "fixed",
                    left: 0,
                    zIndex: 100
                },
                children: /*#__PURE__*/ _jsx(Menu, {
                    selectedKeys: matchRouteObj === null || matchRouteObj === void 0 ? void 0 : matchRouteObj.selectedKeys,
                    defaultOpenKeys: matchRouteObj === null || matchRouteObj === void 0 ? void 0 : matchRouteObj.selectedKeys,
                    theme: "light",
                    mode: "inline",
                    items: items
                })
            }),
            /*#__PURE__*/ _jsxs(ALayout, {
                style: {
                    marginLeft: "180px"
                },
                children: [
                    /*#__PURE__*/ _jsx(TagsView, {
                        dispatch: dispatch,
                        activeKey: matchRouteObj === null || matchRouteObj === void 0 ? void 0 : matchRouteObj.key,
                        tagsViewList: tagsViewList
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        id: "epr-tags",
                        children: /*#__PURE__*/ _jsx(ALayout.Content, {
                            style: {
                                minHeight: "calc(100vh - 95px)",
                                padding: "18px",
                                background: "#f2f2f2"
                            },
                            className: "app-main",
                            children: /*#__PURE__*/ _jsx(SuspenseLoading, {
                                children: /*#__PURE__*/ _jsx(ErrorBoundary, {
                                    children: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(KeepAlive, {
                                                activeName: matchRouteObj === null || matchRouteObj === void 0 ? void 0 : matchRouteObj.key,
                                                include: keepAliveList,
                                                children: /*#__PURE__*/ _jsxs(ErrorBoundary, {
                                                    children: [
                                                        " ",
                                                        eleRef.current
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs(ErrorBoundary, {
                                                children: [
                                                    " ",
                                                    (matchRouteObj === null || matchRouteObj === void 0 ? void 0 : matchRouteObj.cache) ? null : eleRef.current
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
